export default {
  'call-dispatcher': 'Llamar al despachador',
  'error-code': 'Error {code}',
  'dispatcher-hint': 'Si ve este error, póngase en contacto con el despachador de Rx2Go',
  400: {
    title: 'Solicitud incorrecta',
    description: 'Parece que el enlace en el que hizo clic tiene un pequeño problema y no pudimos procesar su solicitud.',
  },
  404: {
    title: 'No encontrado',
    description: 'La página que busca podría haber sido eliminada, haber cambiado de nombre o no estar disponible temporalmente.',
  },
  500: {
    title: 'Error interno del servidor',
    description: 'Encontramos un error inesperado. Por favor, inténtelo de nuevo más tarde.',
  },
  generic: {
    title: 'Algo salió mal',
    description: 'Algo salió mal',
  },
}
